// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCxO5yHNL2kkddLWp1pV_2KlRHQGzhQao8",
  authDomain: "news-portal-e6d7d.firebaseapp.com",
  projectId: "news-portal-e6d7d",
  storageBucket: "news-portal-e6d7d.appspot.com",
  messagingSenderId: "1049621480598",
  appId: "1:1049621480598:web:c8e452d5b88de84f4deeb7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
